import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment'

/**
 * This is a singleton class
 */
@Injectable({ providedIn: 'root' })
export class NewBusinessAppSettings {
    //Provide all the Application Configs here

    public _viewModuleName = "Product Configurator"
    public _allowedRoles = ["ADMIN", "CSR", "AGENT"]
    // public _allowedLOB = "Credit Life";
    public _allowedLOB = "HEALTH";
    public _allowedCurrency = "INR";
    public APPCONSTANTS: any = {
        productFamilyCd: environment['lob'] || 'HEALTH',
        submissionMode: 'PAPER',
        proposalEntryDate: new Date().getTime(),
        productStatus: 'LAUNCHED'
    }

    constructor() {
    }
}
